import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SectionCTA } from '../SectionCTA';
export function Guarantee() {
  return <section className="bg-white px-5 py-14 md:py-20" data-id="element-167" data-mp="20m4opq90saty">
      <div className="mx-auto max-w-3xl text-center" data-id="element-168" data-mp="24monszd5loiq">
        <div className="mx-auto flex h-28 w-28 flex-col items-center justify-center rounded-full border-4 border-gold bg-navy text-white" data-id="element-169" data-mp="24lwzm9lvyt2h">
          <ShieldCheckIcon className="h-8 w-8 text-gold" aria-hidden="true" data-id="element-170" data-mp="2ed9rh17opj8i" />
          <span className="mt-1 text-2xl font-extrabold leading-none" data-id="element-171" data-mp="2efdznvcm94el">7-Day</span>
          <span className="text-[10px] font-bold uppercase tracking-wider text-white/80" data-id="element-172" data-mp="2je7b7i8celc4">Guarantee</span>
        </div>
        <h2 className="mt-6 text-[26px] font-extrabold leading-[1.18] text-navy md:text-4xl" data-id="element-173" data-mp="2scsq93elvi85">
          Your Purchase Is Protected by Our 7-Day Guarantee
        </h2>
        <p className="mt-4 text-base leading-relaxed text-navy/75 md:text-lg" data-id="element-174" data-mp="tyr5ydxjhjri">
          Explore the Postoperative Wound Complications Blueprint™ and review its practical assessment, documentation,
          and communication tools.
        </p>
        <p className="mt-3 text-base leading-relaxed text-navy/75 md:text-lg" data-id="element-175" data-mp="3nuzv7tivnlaz">
          If you&apos;re not satisfied with your purchase, contact our support team within seven days of purchase to
          request a refund under the applicable refund policy.
        </p>
        <p className="mt-4 font-extrabold text-navy" data-id="element-176" data-mp="3dufssnjmgar6">Your purchase is backed by a 7-day money-back guarantee.</p>

        <SectionCTA label="Try It Risk-Free" data-id="element-177" data-mp="aftul1p27gv1" />
      </div>
    </section>;
}